import { CountryCodes } from './types'

export const masks = {
  [CountryCodes.AC]: ['+### ####'],
  [CountryCodes.AD]: ['+### ### ###'],
  [CountryCodes.AE]: ['+### # ### ####'],
  [CountryCodes.AF]: ['+## ## ### ####'],
  [CountryCodes.AG]: ['+# ### ### ####'],
  [CountryCodes.AI]: ['+# ### ### ####'],
  [CountryCodes.AL]: ['+### ### ### ###'],
  [CountryCodes.AM]: ['+### ## ### ###'],
  [CountryCodes.AO]: ['+### ### ### ###'],
  [CountryCodes.AR]: ['+## ### ### ####'],
  [CountryCodes.AS]: ['+# ### ### ####'],
  [CountryCodes.AT]: ['+## ### ### ####'],
  [CountryCodes.AU]: ['+## # #### ####'],
  [CountryCodes.AW]: ['+### ### ####'],
  [CountryCodes.AZ]: ['+### ## ### ## ##'],
  [CountryCodes.BA]: ['+### ## #####', '+### ## ####'],
  [CountryCodes.BB]: ['+# ### ### ####'],
  [CountryCodes.BD]: ['+### ## ### ###'],
  [CountryCodes.BE]: ['+## ### ### ###'],
  [CountryCodes.BF]: ['+### ## ## ####'],
  [CountryCodes.BG]: ['+### ### ### ###'],
  [CountryCodes.BH]: ['+### #### ####'],
  [CountryCodes.BI]: ['+### ## ## ####'],
  [CountryCodes.BJ]: ['+### ## ## ####'],
  [CountryCodes.BM]: ['+# ### ### ####'],
  [CountryCodes.BN]: ['+### ### ####'],
  [CountryCodes.BO]: ['+### # ### ####'],
  [CountryCodes.BR]: ['+## ## #### ####', '+## ## ##### ####'],
  [CountryCodes.BS]: ['+# ### ### ####'],
  [CountryCodes.BT]: ['+### ## ### ###', '+### # ### ###'],
  [CountryCodes.BW]: ['+### ## ### ###'],
  [CountryCodes.BY]: ['+### ## ### ## ##'],
  [CountryCodes.BZ]: ['+### ### ####'],
  [CountryCodes.CA]: ['+# ### ### ####'],
  [CountryCodes.CD]: ['+### ### ### ###'],
  [CountryCodes.CF]: ['+### ## ## ####'],
  [CountryCodes.CG]: ['+### ## ### ####'],
  [CountryCodes.CH]: ['+## ## ### ####'],
  [CountryCodes.CI]: ['+### ## ### ###'],
  [CountryCodes.CK]: ['+### ## ###'],
  [CountryCodes.CL]: ['+## # #### ####'],
  [CountryCodes.CM]: ['+### #### ####'],
  [CountryCodes.CN]: ['+## ### #### ####', '+## ## ##### #####'],
  [CountryCodes.CO]: ['+## ### ### ####'],
  [CountryCodes.CR]: ['+### #### ####'],
  [CountryCodes.CU]: ['+## # ### ####'],
  [CountryCodes.CV]: ['+### ### ## ##'],
  [CountryCodes.CW]: ['+### ### ####'],
  [CountryCodes.CY]: ['+### ## ### ###'],
  [CountryCodes.CZ]: ['+### ### ### ###'],
  [CountryCodes.DE]: [
    '+## ### ## ####',
    '+## ### ### ####',
    '+## #### ### ####',
  ],
  [CountryCodes.DJ]: ['+### ## ## ## ##'],
  [CountryCodes.DK]: ['+## ## ## ## ##'],
  [CountryCodes.DM]: ['+# ### ### ####'],
  [CountryCodes.DO]: ['+# ### ### ####'],
  [CountryCodes.DZ]: ['+### ## ### ####'],
  [CountryCodes.EC]: ['+### ## ### ####', '+### # ### ####'],
  [CountryCodes.EE]: ['+### #### ####', '+### ### ####'],
  [CountryCodes.EG]: ['+## ### ### ####'],
  [CountryCodes.ER]: ['+### # ### ###'],
  [CountryCodes.ES]: ['+## ### ### ###'],
  [CountryCodes.ET]: ['+### ## ### ####'],
  [CountryCodes.FI]: ['+### ### ### ## ##'],
  [CountryCodes.FJ]: ['+### ## #####'],
  [CountryCodes.FK]: ['+### #####'],
  [CountryCodes.FM]: ['+### ### ####'],
  [CountryCodes.FO]: ['+### ### ###'],
  [CountryCodes.FR]: ['+## ### ### ###'],
  [CountryCodes.GA]: ['+### # ## ## ##'],
  [CountryCodes.GB]: ['+## ## #### ####'],
  [CountryCodes.GD]: ['+# ### ### ####'],
  [CountryCodes.GE]: ['+### ### ### ###'],
  [CountryCodes.GF]: ['+### ##### ####'],
  [CountryCodes.GH]: ['+### ### ### ###'],
  [CountryCodes.GI]: ['+### ### #####'],
  [CountryCodes.GL]: ['+### ## ## ##'],
  [CountryCodes.GM]: ['+### ### ## ##'],
  [CountryCodes.GN]: ['+### ## ### ###'],
  [CountryCodes.GQ]: ['+### ## ### ####'],
  [CountryCodes.GR]: ['+## ### ### ####'],
  [CountryCodes.GT]: ['+### # ### ####'],
  [CountryCodes.GU]: ['+# ### ### ####'],
  [CountryCodes.GW]: ['+### # ######'],
  [CountryCodes.GY]: ['+### ### ####'],
  [CountryCodes.HK]: ['+### #### ####'],
  [CountryCodes.HN]: ['+### #### ####'],
  [CountryCodes.HR]: ['+### ## ### ###'],
  [CountryCodes.HT]: ['+### ## ## ####'],
  [CountryCodes.HU]: ['+## ### ### ###'],
  [CountryCodes.ID]: ['+## ### ### ####'],
  [CountryCodes.IE]: ['+### ### ### ###'],
  [CountryCodes.IL]: ['+### # ### ####', '+### ## ### ####'],
  [CountryCodes.IM]: ['+## #### ######'],
  [CountryCodes.IN]: ['+## #### ### ###'],
  [CountryCodes.IO]: ['+### ### ####'],
  [CountryCodes.IQ]: ['+### ### ### ####'],
  [CountryCodes.IR]: ['+## ### ### ####'],
  [CountryCodes.IS]: ['+### ### ####'],
  [CountryCodes.IT]: ['+## ### #### ###'],
  [CountryCodes.JM]: ['+# ### ### ####'],
  [CountryCodes.JO]: ['+### # #### ####'],
  [CountryCodes.JP]: ['+## ## #### ####', '+## ### ### ###'],
  [CountryCodes.KE]: ['+### ### ######'],
  [CountryCodes.KG]: ['+### ### ### ###'],
  [CountryCodes.KH]: ['+### ## ### ###'],
  [CountryCodes.KI]: ['+### ## ###'],
  [CountryCodes.KM]: ['+### ## #####'],
  [CountryCodes.KN]: ['+# ### ### ####'],
  [CountryCodes.KP]: [
    '+### ### ###',
    '+### ## ### ###',
    '+### ### #### ###',
    '+### #### #############',
  ],
  [CountryCodes.KR]: ['+## ## ### ####'],
  [CountryCodes.KW]: ['+### #### ####'],
  [CountryCodes.KY]: ['+# ### ### ####'],
  [CountryCodes.KZ]: ['+# ### ### ## ##'],
  [CountryCodes.LA]: ['+### #### ### ###', '+### ## ### ###'],
  [CountryCodes.LB]: ['+### ## ### ###', '+### # ### ###'],
  [CountryCodes.LC]: ['+# ### ### ####'],
  [CountryCodes.LI]: ['+### ### ### ####'],
  [CountryCodes.LK]: ['+## ## ### ####'],
  [CountryCodes.LR]: ['+### ## ### ###'],
  [CountryCodes.LS]: ['+### # ### ####'],
  [CountryCodes.LT]: ['+### ### ## ###'],
  [CountryCodes.LU]: ['+### ### ### ###'],
  [CountryCodes.LV]: ['+### ## ### ###'],
  [CountryCodes.LY]: ['+### ## ### ###', '+### ## ### ####'],
  [CountryCodes.MA]: ['+### ## #### ###'],
  [CountryCodes.MC]: ['+### ### ### ###', '+### ## ### ###'],
  [CountryCodes.MD]: ['+### #### ####'],
  [CountryCodes.ME]: ['+### ## ### ###'],
  [CountryCodes.MG]: ['+### ## ## #####'],
  [CountryCodes.MH]: ['+### ### ####'],
  [CountryCodes.MK]: ['+### ## ### ###'],
  [CountryCodes.ML]: ['+### ## ## ####'],
  [CountryCodes.MM]: ['+## ## ### ###', '+## # ### ###', '+## ### ###'],
  [CountryCodes.MN]: ['+### ## ## ####'],
  [CountryCodes.MO]: ['+### #### ####'],
  [CountryCodes.MP]: ['+# ### ### ####'],
  [CountryCodes.MQ]: ['+### ### ## ## ##'],
  [CountryCodes.MR]: ['+### ## ## ####'],
  [CountryCodes.MS]: ['+# ### ### ####'],
  [CountryCodes.MT]: ['+### #### ####'],
  [CountryCodes.MU]: ['+### ### ####'],
  [CountryCodes.MV]: ['+### ### ####'],
  [CountryCodes.MW]: ['+### # ### ###', '+### # #### ####'],
  [CountryCodes.MX]: ['+## ### ### ####', '+## ## ## ####'],
  [CountryCodes.MY]: [
    '+## ## ### ####',
    '+## ### ### ###',
    '+## ## ### ###',
    '+## # ### ###',
  ],
  [CountryCodes.MZ]: ['+### ## ### ###'],
  [CountryCodes.NA]: ['+### ## ### ####'],
  [CountryCodes.NC]: ['+### ## ####'],
  [CountryCodes.NE]: ['+### ## ## ####'],
  [CountryCodes.NF]: ['+### ### ###'],
  [CountryCodes.NG]: ['+### ### ### ####', '+### ## ### ###', '+### ## ### ##'],
  [CountryCodes.NI]: ['+### #### ####'],
  [CountryCodes.NL]: ['+## ## ### ####'],
  [CountryCodes.NO]: ['+## ### ## ###'],
  [CountryCodes.NP]: ['+### ## ### ###'],
  [CountryCodes.NR]: ['+### ### ####'],
  [CountryCodes.NU]: ['+### ####'],
  [CountryCodes.NZ]: ['+## ### ### ###', '+## ## ### ###', '+## ### ### ####'],
  [CountryCodes.OM]: ['+### ## ### ###'],
  [CountryCodes.PA]: ['+### ### ####'],
  [CountryCodes.PE]: ['+## ### ### ###'],
  [CountryCodes.PF]: ['+### ## ## ##'],
  [CountryCodes.PG]: ['+### ### ## ###'],
  [CountryCodes.PH]: ['+## ### ### ####'],
  [CountryCodes.PK]: ['+## ### ### ####'],
  [CountryCodes.PL]: ['+## ### ### ###'],
  [CountryCodes.PR]: ['+# ### ### ####'],
  [CountryCodes.PS]: ['+### ## ### ####'],
  [CountryCodes.PT]: ['+### ## ### ####'],
  [CountryCodes.PW]: ['+### ### ####'],
  [CountryCodes.PY]: ['+### ### ### ###'],
  [CountryCodes.QA]: ['+### #### ####'],
  [CountryCodes.RE]: ['+### ##### ####'],
  [CountryCodes.RO]: ['+## ## ### ####'],
  [CountryCodes.RS]: ['+### ## ### ####'],
  [CountryCodes.RU]: ['+# ### ### ## ##'],
  [CountryCodes.RW]: ['+### ### ### ###'],
  [CountryCodes.SA]: ['+### # #### ####', '+### # ### ####'],
  [CountryCodes.SB]: ['+### ### ####', '+### #####'],
  [CountryCodes.SC]: ['+### # ### ###'],
  [CountryCodes.SD]: ['+### ## ### ####'],
  [CountryCodes.SE]: ['+## ## ### ####'],
  [CountryCodes.SG]: ['+## #### ####'],
  [CountryCodes.SH]: ['+### ####'],
  [CountryCodes.SI]: ['+### ## ### ###'],
  [CountryCodes.SK]: ['+### ### ### ###'],
  [CountryCodes.SL]: ['+### ## ######'],
  [CountryCodes.SM]: ['+### #### ######'],
  [CountryCodes.SN]: ['+### ## ### ####'],
  [CountryCodes.SO]: ['+### ## ### ###', '+### # ### ###'],
  [CountryCodes.SR]: ['+### ### ####', '+### ### ###'],
  [CountryCodes.SS]: ['+### ## ### ####'],
  [CountryCodes.ST]: ['+### ## #####'],
  [CountryCodes.SV]: ['+### ## ## ####'],
  [CountryCodes.SX]: ['+### ### ### ####'],
  [CountryCodes.SY]: ['+### ## #### ###'],
  [CountryCodes.SZ]: ['+### ## ## ####'],
  [CountryCodes.TC]: ['+### ### ### ####'],
  [CountryCodes.TD]: ['+### ## ## ## ##'],
  [CountryCodes.TG]: ['+### ## ### ###'],
  [CountryCodes.TH]: ['+## ## ### ####', '+## ## ### ###'],
  [CountryCodes.TJ]: ['+### ## ### ####'],
  [CountryCodes.TK]: ['+### ####'],
  [CountryCodes.TL]: ['+### ### ####', '+### ### #####', '+### ### #####'],
  [CountryCodes.TM]: ['+### # ### ####'],
  [CountryCodes.TN]: ['+### ## ### ###'],
  [CountryCodes.TO]: ['+### #####'],
  [CountryCodes.TR]: ['+## ### ### ####'],
  [CountryCodes.TT]: ['+# ### ### ####'],
  [CountryCodes.TV]: ['+### ######', '+### ####'],
  [CountryCodes.TW]: ['+### # #### ####', '+### #### ####'],
  [CountryCodes.TZ]: ['+### ## ### ####'],
  [CountryCodes.UA]: ['+### ## ### ## ##'],
  [CountryCodes.UG]: ['+### ### ### ###'],
  [CountryCodes.US]: ['+# ### ### ####'],
  [CountryCodes.UY]: ['+### # ### ## ##'],
  [CountryCodes.UZ]: ['+### ## ### ####'],
  [CountryCodes.VA]: ['+## # ### #####'],
  [CountryCodes.VC]: ['+# ### ### ####'],
  [CountryCodes.VE]: ['+## ### ### ####'],
  [CountryCodes.VG]: ['+# ### ### ####'],
  [CountryCodes.VI]: ['+# ### ### ####'],
  [CountryCodes.VN]: ['+## ## #### ###', '+## ### #### ###'],
  [CountryCodes.VU]: ['+### ## #####', '+### #####'],
  [CountryCodes.WF]: ['+### ## ####'],
  [CountryCodes.WS]: ['+### ## ####'],
  [CountryCodes.YE]: ['+### ### ### ###', '+### # ### ###', '+### ## ### ###'],
  [CountryCodes.YT]: ['+### ##### ####'],
  [CountryCodes.ZA]: ['+## ## ### ####'],
  [CountryCodes.ZM]: ['+### ## ### ####'],
  [CountryCodes.ZW]: ['+### # ######'],
} as const
